export const AGGREGATED_TITLES = {
  tax_id_platform_creaction: 'TaxID: Creación en plataforma',
  contact_user_register: 'Usuario: Registro en la plataforma',
  contact_legal_user_register: 'Representante Legal: Registro en la plataforma'
}

export const VALIDATION_STATUS = {
  PENDING: 0,
  CANCEL: 1,
  SYSTEM_ERROR: 2,
  VALIDATION_ERROR: 3,
  MANUAL_ACTION: 4,
  SUCCESS: 5
}

export const REGISTER_BY_COUNTRY = {
  ARGENTINA: 'ARGENTINA',
  PERU: 'PERU',
  CHILE: 'CHILE'
}

export const RETRY_STATUS = [
  VALIDATION_STATUS.PENDING,
  VALIDATION_STATUS.SYSTEM_ERROR,
  VALIDATION_STATUS.VALIDATION_ERROR
]

export const STATUS_TOOLTIPS = {
  [VALIDATION_STATUS.PENDING]: 'Pendiente',
  [VALIDATION_STATUS.CANCEL]: 'Cancelado',
  [VALIDATION_STATUS.SYSTEM_ERROR]: 'Error del sistema',
  [VALIDATION_STATUS.VALIDATION_ERROR]: 'Error de validación',
  [VALIDATION_STATUS.MANUAL_ACTION]: 'Acción manual requerida',
  [VALIDATION_STATUS.SUCCESS]: 'Completado'
}

export const DETERMINISTIC_STEPS = {
  tax_id_marketplace_validation: 'tax_id_marketplace_validation',
  tax_id_locked_marketplace_validation: 'tax_id_locked_marketplace_validation',
  tax_id_cat4mro_validation: 'tax_id_cat4mro_validation',
  tax_id_locked_cat4mro_validation: 'tax_id_locked_cat4mro_validation',
  tax_id_terms_validation: 'tax_id_terms_validation',
  contact_email: 'contact_email',
  contact_email_format_validation: 'contact_email_format_validation',
  contact_legal_email: 'contact_legal_email',
  contact_legal_email_format_validation: 'contact_legal_email_format_validation'
}

export const DETERMINISTIC_MARKETPLACE_STEPS = [
  DETERMINISTIC_STEPS.tax_id_marketplace_validation,
  DETERMINISTIC_STEPS.tax_id_locked_marketplace_validation
]

export const DETERMINISTIC_CAT4MRO_STEPS = [
  DETERMINISTIC_STEPS.tax_id_cat4mro_validation,
  DETERMINISTIC_STEPS.tax_id_locked_cat4mro_validation,
  DETERMINISTIC_STEPS.tax_id_terms_validation
]

export const USAGE_STEPS_TYPES = {
  hubspot_integration: 'hubspot_integration',
  tax_id_terms_validation: 'tax_id_terms_validation',
  tax_id_validation: 'tax_id_validation',
  tax_id_platform_creaction: 'tax_id_platform_creaction',
  tax_id_marketplace_validation: 'tax_id_marketplace_validation',
  tax_id_cat4mro_validation: 'tax_id_cat4mro_validation',
  tax_id_gob_validation: 'tax_id_gob_validation',
  tax_id_locked_marketplace_validation: 'tax_id_locked_marketplace_validation',
  contact_user_register: 'contact_user_register',
  contact_email_format_validation: 'contact_email_format_validation',
  contact_email_marketplace_validation: 'contact_email_marketplace_validation',
  contact_email_cat4mro_validation: 'contact_email_cat4mro_validation',
  contact_email_sendgrid_validation: 'contact_email_sendgrid_validation',
  contact_email_credentials_validation: 'contact_email_credentials_validation',
  contact_email_credentials_notification: 'contact_email_credentials_notification',
  contact_email_marketplace_locked_validation: 'contact_email_marketplace_locked_validation',
  contact_legal_user_register: 'contact_legal_user_register',
  contact_legal_email_format_validation: 'contact_legal_email_format_validation',
  contact_legal_email_marketplace_validation: 'contact_legal_email_marketplace_validation',
  contact_legal_email_cat4mro_validation: 'contact_legal_email_cat4mro_validation',
  contact_legal_email_sendgrid_validation: 'contact_legal_email_sendgrid_validation',
  contact_legal_email_credential_validation: 'contact_legal_email_credential_validation',
  contact_legal_email_credential_notification: 'contact_legal_email_credential_notification',
  contact_legal_email_marketplace_locked_validation: 'contact_legal_email_marketplace_locked_validation'
}

export const SEND_CREDENTIALS_STEPS = [
  USAGE_STEPS_TYPES.contact_email_credentials_notification,
  USAGE_STEPS_TYPES.contact_legal_email_credential_notification
]

export const MANUAL_VALIDATION_STEPS = [
  USAGE_STEPS_TYPES.tax_id_validation
]

export function validateDataAreComplete (record, fieldsToValidate) {
  const requiredCompanyFields = [
    'tax_id', 'country', 'company_name', 'company_legal_name', 'company_address', 'customer_type',
    'company_business', 'marketplace_timezone_id', 'contract_start_date', 'contract_end_date'
  ]

  const requiredContactFields = [
    'contact_name', 'contact_lastname', 'contact_email', 'contact_phone', 'contact_position'
  ]

  const requiredContactLegalFields = [
    'contact_legal_name', 'contact_legal_lastname', 'contact_legal_email', 'contact_legal_phone', 'contact_legal_position'
  ]

  let requiredFields
  if (fieldsToValidate === 'company') {
    requiredFields = requiredCompanyFields
  } else if (fieldsToValidate === 'contact') {
    requiredFields = requiredContactFields
  } else if (fieldsToValidate === 'contact_legal') {
    requiredFields = requiredContactLegalFields
  }

  for (const field of requiredFields) {
    if (!record[field]) {
      return false
    }
  }

  return true
}



// WEBPACK FOOTER //
// ./src/utils/validationSteps.js